import { ALTERAR_EMPRESA_SELECIONADA } from '../actions/types'
import { getEmpresaSelecionada } from '../util/empresaSelecionada';

const initialState = undefined
const inicial = getEmpresaSelecionada()

export default function reducerEmpresaSelecionada (state = inicial, action = initialState) {
  switch (action.type) {
    case ALTERAR_EMPRESA_SELECIONADA: {
      return action.payload
    }

    default:
      return state
  }
}